export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-24 bg-white">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="max-w-4xl mx-auto">
          <div className="rounded-2xl bg-gradient-to-br from-primary-500 via-primary-500 to-accent-500 p-8 md:p-12">
            <div className="flex flex-col md:flex-row items-center gap-8">
              <div className="flex-1 text-center md:text-left">
                <h2 className="text-2xl md:text-3xl font-bold text-white font-serif mb-3">
                  随时随地，畅享高清影视
                </h2>
                <p className="text-sm text-white/80 leading-relaxed mb-6">
                  苹果视频全面适配手机、平板和电脑浏览器，无需下载APP，打开浏览器即可在线观看。收藏本页到手机桌面，使用体验堪比原生应用，随时随地畅享50000+高清影视资源。
                </p>
                <div className="flex flex-wrap items-center justify-center md:justify-start gap-4">
                  <a
                    href="#app"
                    className="inline-flex items-center gap-2 px-6 py-3 bg-white text-primary-500 font-medium rounded-lg hover:bg-white/90 transition-all duration-200 whitespace-nowrap text-sm"
                  >
                    <i className="ri-smartphone-line text-lg"></i>
                    手机端体验
                  </a>
                  <a
                    href="#app"
                    className="inline-flex items-center gap-2 px-6 py-3 bg-white/20 text-white font-medium rounded-lg hover:bg-white/30 transition-all duration-200 whitespace-nowrap text-sm"
                  >
                    <i className="ri-computer-line text-lg"></i>
                    电脑端体验
                  </a>
                </div>
              </div>
              <div className="flex-shrink-0">
                <div className="w-40 h-40 rounded-3xl bg-white/20 backdrop-blur flex items-center justify-center">
                  <div className="text-center">
                    <i className="ri-play-circle-fill text-white text-5xl block mb-1"></i>
                    <span className="text-white/90 text-sm font-medium">苹果视频</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}